import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; // Import useLocation
import "./Navbar.css";

const Navbar = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const location = useLocation(); // Hook to get current route

    const menuItems = [
        {
            label: "Home",
            path: "/",
        },
        {
            label: "About Us",
            path: "/about",
            dropdown: [
                { label: "Church Staff", path: "/about/church-staff" },
                { label: "Bishop's Circle", path: "/about/bishops-circle" },
            ],
        },
        {
            label: "Community",
            path: "/community",
            dropdown: [
                { label: "Master's Table", path: "/community/masters-table" },
                {
                    label: "Foster Care Transitional Services",
                    path: "/community/foster-care",
                },
            ],
        },
        {
            label: "Get Involved",
            path: "/get-involved",
            dropdown: [
                { label: "Our Ministries", path: "/get-involved/our-ministries" },
                { label: "Weekly Program", path: "/get-involved/weekly-program"},
                { label: "Calendar", path: "/get-involved/calendar"},
                { label: "Prayer", path: "/get-involved/prayer"},
                { label: "Questions", path: "/get-involved/questions"},
            ],
        },
        {
            label: "Media",
            path: "/media",
            dropdown: [
                { label: "Blog", path: "/media/blog" },
                { label: "Devotional", path: "/media/devotional" },
            ],
        },
        { label: "GIVE", path: "/give" },
        { label: "Contact Us", path: "/contact" },
    ];

    useEffect(() => {
        const updateMobileStatus = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        // Close the menu when the route changes
        setIsOpen(false);

        updateMobileStatus();
        window.addEventListener("resize", updateMobileStatus);
        return () => window.removeEventListener("resize", updateMobileStatus);
    }, [location]); // Trigger when the route changes

    const renderMobileButton = (item, index) => {
        return (
            <li key={index} className="w-full">
                <Link
                    to={item.path}
                    className="block px-4 py-2 bg-red-700 text-left hover:bg-red-700 hover:text-white"
                >
                    {item.label}
                </Link>
                {item.dropdown && (
                    <ul className="bg-red-800">
                        {item.dropdown.map((subItem, subIndex) => (
                            <li
                                key={subIndex}
                                className="block px-6 py-2 bg-red-800 hover:bg-red-700 text-white"
                            >
                                <Link to={subItem.path}>{subItem.label}</Link>
                            </li>
                        ))}
                    </ul>
                )}
            </li>
        );
    };

    const renderDesktopButton = (item, index) => {
        return (
            <li key={index} className="relative group">
                <Link
                    to={item.path}
                    className="block px-4 py-2 hover:bg-red-700 hover:text-white"
                >
                    {item.label}
                </Link>
                {item.dropdown && (
                    <ul
                        className="absolute left-0 top-full bg-white text-black shadow-lg z-10 hidden group-hover:block"
                        style={{ minWidth: "200px" }}
                    >
                        {item.dropdown.map((subItem, subIndex) => (
                            <li
                                key={subIndex}
                                className="px-4 py-2 hover:bg-gray-200"
                            >
                                <Link to={subItem.path}>{subItem.label}</Link>
                            </li>
                        ))}
                    </ul>
                )}
            </li>
        );
    };

    return (
        <nav className="bg-red-900 text-white">
            <div className="container mx-auto flex flex-wrap max-w-7xl items-center justify-between p-4">
                {/* Logo Section */}
                <div className="flex items-center w-full space-x-4">
                    <div className="relative w-32 h-32">
                        <div
                            className="absolute inset-0 bg-cover bg-center rounded-lg logo-animation"
                            style={{
                                backgroundImage: `url('/assets/images/Untitled-2fw.png')`,
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat'
                            }}
                        ></div>
                        <div
                            className="absolute inset-0 bg-cover bg-center rounded-lg"
                            style={{
                                backgroundImage: `url('/assets/images/Untitled-1fw.png')`,
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat'
                            }}
                        ></div>
                    </div>
                    <h1
                        className={`navbar-title ${isMobile ? "mobile" : "desktop"}`}
                    >
                        Solid Rock Cathedral Of Faith
                    </h1>
                    {/* Hamburger Menu for Mobile */}
                    <button
                        className="md:hidden text-white flex-auto text-right hover:text-gray-400 focus:outline-none"
                        onClick={() => setIsOpen(!isOpen)}
                    >
                        ☰
                    </button>
                </div>



                {/* Menu Links */}
                <div
                    className={`w-full md:w-auto md:flex flex-col flex-auto md:flex-row items-center md:space-x-4 ${
                        isOpen ? "block" : "hidden"
                    }`}
                >
                    <ul className="pt-6 w-full flex flex-col md:flex-row items-center space-y-4 flex-auto justify-between md:space-y-0">
                        {menuItems.map((item, index) =>
                            isMobile
                                ? renderMobileButton(item, index)
                                : renderDesktopButton(item, index)
                        )}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
